module.exports = __webpack_public_path__ + "img/code.a20f5c79.png";